import axios from 'axios';
import { frontendConfig } from '../helpers/frontend_config';

const baseURL = '/api/homes';
const photoURL = '/api/photos';
const settingsURL = '/api/user_settings';
const blogPostsURL = '/api/blog_posts';


const handleError = fn => (...params) =>
  fn(...params).catch(error => {
      // TODO: do I need this method?
      return { error: error };
  });

export const api = {
  // Search
  getHomes: handleError(async () => {
    const res = await axios.get(baseURL);
    return res.data;
  }),
  getRecentHomes: handleError(async (limit) => {
    const res = await axios.get(baseURL+'/recent?limit='+limit);
    return res.data;
  }),
  searchForHomes: handleError(async (searchQuery, previous, shouldPaginate, user) => {
    const res = await axios.post(baseURL+'/search',
        {
            'query': searchQuery,
            'previous': previous,
            'shouldPaginate': shouldPaginate,
            'user': user,
        });
    return res.data;
  }),
  getHomeById: handleError(async (id, user) => {
    const res = await axios.post(baseURL+'/details/'+id, { user });
    return res.data;
  }),

  // User management
  getUserSettings: handleError(async (user) => {
      const res = await axios.get(
          `${settingsURL}/${user.id}`,
          {params: {'email': user.email}}
      );
      return res.data;
  }),
  updateUserSettings: handleError(async (newSettings) => {
      // marlee: this would be a really good one to add authentication for
      const userId = newSettings.user_id || newSettings.auth0_id;
      const res = await axios.post(`${settingsURL}/${userId}`, newSettings);
      return res.data;
  }),
  getShareableUserIds: handleError(async () => {
    const res = await axios.get(`${settingsURL}/shareable`);
    return res.data;
  }),

  // Create, update, delete homes
  submitHome: handleError(async (homeData) => {
      const res = await axios.post(baseURL, homeData);
      return res.data;
  }),
  updateHome: handleError(async (updatedHome, homeId) => {
    const res = await axios.put(baseURL + '/'+homeId, updatedHome);
    return res.data;
  }),
  deleteHome: handleError(async id => {
    const res = await axios.delete(baseURL + '/' + id);
    return res.data;
  }),
  bulkSubmitHomes: handleError(async (homesList) => {
      const res = await axios.post(baseURL + '/bulk', homesList);
      return res.data;
  }),

  // Photos
  deletePhoto: handleError(async (photoName) => {
      const body = { keyToDelete: photoName };
      const res = await axios.post(photoURL+'/delete', body);
      return res.data;
  }),

  // blog
  getBlogPosts: handleError(async (previous) => {
      const res = await axios.get(blogPostsURL, {params: {'previous': previous}});
      return res.data;
  }),
  publishBlogPost: handleError(async (postContents) => {
    const res = await axios.post(blogPostsURL, postContents);
    return res.data;
  }),
  updateBlogPost: handleError(async (id, postContents) => {
      const res = await axios.put(blogPostsURL + '/' + id, postContents);
      return res.data;
  }),
  deleteBlogPost: handleError(async id => {
      const res = await axios.delete(blogPostsURL + '/' + id);
      return res.data;
  }),

  // Google Maps API
  autofillLocation: handleError(async coordinates => {
      const res = await axios.get(
          'https://maps.googleapis.com/maps/api/geocode/json?key='
          + frontendConfig.GOOGLE_MAPS_API_KEY
          + '&language=en&latlng='+coordinates.lat+','+coordinates.lng);
      return res;
  }),
  searchByAddress: handleError(async searchStr => {
      const res = await axios.get(
          'https://maps.googleapis.com/maps/api/geocode/json?key='
          + frontendConfig.GOOGLE_MAPS_API_KEY
          + '&language=en&address='+searchStr
      )
      return res;
  })
};